import { fromPromise } from 'xstate';

import { inferPetitionScopeLocation } from '#src/app/pages/startAPetitionV2/shared/api';

import type { InferScopeLocationInput, InferScopeLocationOutput, OrchestrationDeps } from '../../types';

/** The scope/location inference operation: one `inferPetitionScopeLocation` call, run by the orchestrator's region. */
export const createLogic = ({ utilityContext, track }: Pick<OrchestrationDeps, 'utilityContext' | 'track'>) =>
	fromPromise<InferScopeLocationOutput, InferScopeLocationInput>(async ({ input }) =>
		inferPetitionScopeLocation(input, { utilityContext, track }),
	);
